module.exports = __webpack_public_path__ + "static/assets/65934f70482a1fe4ba080d2c95a725f5.png";